export let ActiveServicesReportOptionalColumns = /*#__PURE__*/function (ActiveServicesReportOptionalColumns) {
  ActiveServicesReportOptionalColumns["Trigger"] = "Trigger";
  ActiveServicesReportOptionalColumns["Pricing"] = "Pricing";
  ActiveServicesReportOptionalColumns["Occurrence"] = "Occurrence";
  ActiveServicesReportOptionalColumns["Rate"] = "Rate";
  ActiveServicesReportOptionalColumns["LastBilled"] = "Last billed";
  ActiveServicesReportOptionalColumns["Assignee"] = "Assignee";
  ActiveServicesReportOptionalColumns["AutomaticServiceState"] = "Automatic service state";
  ActiveServicesReportOptionalColumns["Status"] = "Status";
  return ActiveServicesReportOptionalColumns;
}({});
export let FilterType = /*#__PURE__*/function (FilterType) {
  FilterType["CustomerName"] = "company";
  FilterType["AgreementName"] = "agreement";
  FilterType["ServiceName"] = "service";
  FilterType["Occurrence"] = "occurrence";
  FilterType["Trigger"] = "trigger";
  FilterType["Pricing"] = "pricing";
  FilterType["LastBilled"] = "lastBilled";
  FilterType["Assignee"] = "assignee";
  FilterType["AutomaticServiceState"] = "automaticServiceState";
  FilterType["Status"] = "status";
  return FilterType;
}({});